import React from 'react';
import PropTypes from 'prop-types';
import Thanks from '@components/pages/Thanks/Thanks';
import {
  Wrapper,
  LoaderImage,
  LoaderImageWrapper,
  ContentTitle,
  Content,
  ContentText,
  SubText,
  Comma,
} from './Loader.styled.js';
import loader from './resources/loader.gif';
import Title from '@components/molecules/Title/Title';

const globalConfig = global.window?.Config;

const Loader = ({saved, isSubmitting, apiTimeout, apiNoResponse, children}) => {
  const redirectTo = (url) => {
    window.location.replace(url);
    return null;
  };

  if (apiTimeout) {
    if (globalConfig.redirect?.onTimeout) {
      return redirectTo(globalConfig.redirect.onTimeout);
    }
    return <Thanks />;
  }

  if (apiNoResponse) {
    if (globalConfig.redirect?.onNoResponse) {
      return redirectTo(globalConfig.redirect.onNoResponse);
    }
    return <Thanks />;
  }

  if (saved) {
    if (globalConfig.redirect?.onSuccess) {
      return redirectTo(globalConfig.redirect.onSuccess);
    }
    return <Thanks />;
  }

  return (
    <Wrapper data-testid='test_loader'>
      {(isSubmitting && (
        <Content>
          <Title title='Bien reçu' context='loader' />
          <ContentText>
            <ContentTitle>Veuillez patienter</ContentTitle>
            <Comma>, </Comma>
            nous traitons votre demande.
          </ContentText>
          <LoaderImageWrapper>
            <LoaderImage src={loader} />
          </LoaderImageWrapper>
          <SubText>Nous vous redirigeons dans quelques secondes…</SubText>
        </Content>
      )) ||
        children}
    </Wrapper>
  );
};

Loader.propTypes = {
  saved: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  apiTimeout: PropTypes.bool.isRequired,
  apiNoResponse: PropTypes.bool.isRequired,
};
export default Loader;
